"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJEntity = void 0;
class CGJEntity extends Phaser.Physics.Arcade.Sprite {
    constructor(scene, animPrefix, pos, size, hitbox) {
        super(scene, pos.x, pos.y, animPrefix);
        this.originY = 1;
        this.originX = 0.5;
        this.animPrefix = animPrefix;
        this.dead = false;
        this.hitbox = hitbox;
        scene.add.existing(this);
        scene.physics.add.existing(this);
        this.body.setSize(hitbox.width, hitbox.height);
        this.body.setOffset(hitbox.x, hitbox.y);
        this.setDisplaySize(size, size);
        this.setCollideWorldBounds(true);
        this.changeDirection();
    }
    kill() {
        this.body.destroy();
        this.dead = true;
        this.anims.stop();
        this.setTexture(this.animPrefix + "Dead");
        this.scene.time.addEvent({ delay: 1000, callback: () => {
                this.scene.add.tween({
                    targets: this,
                    duration: 1000,
                    alpha: 0,
                    onComplete: () => {
                        this.destroy();
                    }
                });
            } });
    }
    birth() {
        this.setImmovable(true);
    }
    update(now, delta) {
        this.changeDirection();
    }
    changeDirection() {
        if (this.dead)
            return;
        let newAnim = null;
        this.setDepth(this.y + this.displayHeight * (1 - this.originY));
        if (this.body.velocity.x == 0 && this.body.velocity.y == 0 && this.anims.currentAnim) {
            this.anims.setCurrentFrame(this.anims.currentAnim.frames[0]);
            this.anims.stop();
            return;
        }
        if (Math.abs(this.body.velocity.x) > Math.abs(this.body.velocity.y)) {
            if (this.body.velocity.x > 0)
                newAnim = this.animPrefix + 'E';
            else
                newAnim = this.animPrefix + 'W';
        }
        else {
            if (this.body.velocity.y > 0)
                newAnim = this.animPrefix + 'S';
            else
                newAnim = this.animPrefix + 'N';
        }
        if (!this.currentAnim || !this.anims.isPlaying || this.currentAnim != newAnim) {
            this.currentAnim = newAnim;
            this.play(newAnim);
        }
    }
}
exports.CGJEntity = CGJEntity;
